/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteUniversalTeamMemberResponse
 */
export interface InviteUniversalTeamMemberResponse {
    /**
     * 
     * @type {string}
     * @memberof InviteUniversalTeamMemberResponse
     */
    invitationId: string;
    /**
     * 
     * @type {number}
     * @memberof InviteUniversalTeamMemberResponse
     */
    expiresAt: number;
}

/**
 * Check if a given object implements the InviteUniversalTeamMemberResponse interface.
 */
export function instanceOfInviteUniversalTeamMemberResponse(value: object): value is InviteUniversalTeamMemberResponse {
    if (!('invitationId' in value) || value['invitationId'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function InviteUniversalTeamMemberResponseFromJSON(json: any): InviteUniversalTeamMemberResponse {
    return InviteUniversalTeamMemberResponseFromJSONTyped(json, false);
}

export function InviteUniversalTeamMemberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteUniversalTeamMemberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitationId': json['invitationId'],
        'expiresAt': json['expiresAt'],
    };
}

export function InviteUniversalTeamMemberResponseToJSON(json: any): InviteUniversalTeamMemberResponse {
    return InviteUniversalTeamMemberResponseToJSONTyped(json, false);
}

export function InviteUniversalTeamMemberResponseToJSONTyped(value?: InviteUniversalTeamMemberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitationId': value['invitationId'],
        'expiresAt': value['expiresAt'],
    };
}

